import {
    SET_USER,
    SET_TERMS_CONDITIONS,
    SET_SHOW_PASSWORD_MODAL
} from "@/views/login/store/types/types.js";

const mutations = {
    [SET_USER]: (state, payload) => state.user = payload,
    [SET_TERMS_CONDITIONS]: (state, payload) => state.terms_conditions = payload,
    [SET_SHOW_PASSWORD_MODAL]: (state, payload) => state.userPassword = payload
};

export default mutations